import { render } from "./comprehensive_liveness_verification.html?vue&type=template&id=0b1c69ce&external"
import script from "./comprehensive_liveness_verification.js?vue&type=script&lang=js&external"
export * from "./comprehensive_liveness_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__